<!-- Dialog sempre no template (mesmo padrão do ticket-bulk-maintenance): o `visible` é que
     controla a exibição. Só o CONTEÚDO depende de haver sugestão. -->
<p-dialog
  [header]="header()"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  appendTo="body"
  [baseZIndex]="10050"
  [style]="{ width: '520px', 'max-width': '94vw' }"
  [breakpoints]="{ '640px': '96vw' }"
  styleClass="ticket-automation-dialog">
  @if (suggestion(); as s) {
    <div class="tk-autom-body">
      <div class="tk-autom-message">
        <i class="pi pi-info-circle tk-autom-icon"></i>
        <span>{{ message() }}</span>
      </div>

      @if (!isBatch() && s.tickets[0]) {
        <!-- Número visível também no caso unitário: o modal pode aparecer logo depois de o
             usuário fechar o chamado, e aí "o chamado" sozinho é ambíguo. -->
        <div class="tk-autom-single">
          Chamado <strong>{{ s.tickets[0].number }}</strong>
          @if (s.tickets[0].customer) {
            <span class="tk-autom-item-customer">{{ s.tickets[0].customer }}</span>
          }
        </div>
      }

      @if (isBatch()) {
        <div class="tk-autom-list-header">
          <span>Chamados que serão alterados</span>
          <span class="tk-autom-count">{{ total() }}</span>
        </div>
        <div class="tk-autom-list">
          @for (t of s.tickets; track t.id) {
            <div class="tk-autom-item">
              <span class="tk-autom-item-number">{{ t.number }}</span>
              @if (t.summary) {
                <span class="tk-autom-item-summary" [title]="t.summary">{{ t.summary }}</span>
              }
              @if (t.customer) {
                <span class="tk-autom-item-customer">{{ t.customer }}</span>
              }
            </div>
          }
        </div>
      }

      @if (applying() && isBatch()) {
        <div class="tk-autom-progress">Aplicando {{ appliedCount() }}/{{ total() }}…</div>
      }
    </div>
  }

  <ng-template #footer>
    <p-button
      [label]="rejectLabel()"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      [disabled]="applying()"
      (onClick)="onReject()" />
    <p-button
      [label]="acceptLabel()"
      icon="pi pi-check"
      [loading]="applying()"
      (onClick)="onAccept()" />
  </ng-template>
</p-dialog>
